import React, { useState, useRef } from 'react';

const AlphabetizedAccordionList = ({
  fieldName = '',
  options = [],
  defaultSelected = [],
  onChange = () => { },
  mostUsedOptions = []
}) => {
  const [selected, setSelected] = useState(defaultSelected);
  const sectionRefs = useRef({});

  const handleToggle = (value) => {
    const updated = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];

    setSelected(updated);
    onChange(fieldName, updated);
  };

  const scrollToLetter = (letter) => {
    const ref = sectionRefs.current[letter];
    if (ref && ref.scrollIntoView) {
      ref.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const groupedOptions = options.reduce((acc, item) => {
    const firstChar = item[0].toUpperCase();
    acc[firstChar] = acc[firstChar] || [];
    acc[firstChar].push(item);
    return acc;
  }, {});

  const alphabet = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];

  return (
    <>
      {/* Selected Tags */}
      {selected.length > 0 && (
        <div className="mb-2">
          {selected.map((item) => (
            <div
              key={item}
              className="badge badge-pill badge-theme mr-2 mb-2"
            >
              {item}
              <button
                type="button"
                className="ml-1 p-0 btn btn-link text-white"
                onClick={() => handleToggle(item)}
              >
                &times;
              </button>
            </div>
          ))}
        </div>
      )}

      {mostUsedOptions.length > 0 && (
        <div className="row mt-1">
          <div className="col-md-12">
            <label htmlFor="#">Frequently used cultural sub-groups</label>
          </div>
          {mostUsedOptions.map((item) => (
            <div className="col-md-4 mb-3" key={`most-used-${item}`}>
              <div className="custom-form-check">
                <input
                  type="checkbox"
                  id={`check1-${item}`}
                  checked={selected.includes(item)}
                  onChange={() => handleToggle(item)}
                />
                <label htmlFor={`check1-${item}`}>{item}</label>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="row gloassary">
        {/* Main List */}
        <div className="col-11 leftCOnter">
          {alphabet.map((letter) =>
            groupedOptions[letter] ? (
              // eslint-disable-next-line no-return-assign
              <div key={letter} ref={(el) => (sectionRefs.current[letter] = el)}>
                <h5 className="laterHead">{letter}</h5>
                <div className="row">
                  {groupedOptions[letter].map((item) => (
                    <div className="col-md-4 mb-3" key={item}>

                      <div className="custom-form-check">
                        <input
                          type="checkbox"
                          id={`check-${item}`}
                          checked={selected.includes(item)}
                          onChange={() => handleToggle(item)}
                        />
                        <label htmlFor={`check-${item}`}>{item}</label>
                      </div>

                    </div>
                  ))}
                </div>
              </div>
            ) : null
          )}
        </div>

        {/* Alphabet Sidebar */}
        <div className="col-1 d-flex flex-column align-items-center pl-0 counter">
          {alphabet.map((letter) => (
            <button
              type='button'
              key={letter}
              className="btn btn-link p-1"
              onClick={() => scrollToLetter(letter)}
              style={{ fontSize: '12px', lineHeight: '1' }}
            >
              {letter}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default AlphabetizedAccordionList;
